<template>
    <div class="LocationSearch">
        <input
        autocomplete="off"
        :name="name"
        v-model="locSearchValue"
        @input="onChange"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @keyup="onKeyUp"
        :disabled="disabled"
        type="text"
        :id="id"
        :class='classes'
        :ref='reference'
        />
        <ul
        v-show="isOpen"
        class="autocomplete-results"
        :key="loadIdx"
        >
        <li
            v-if="isLoading"
            class="loading"
        >
            Loading results...
        </li>
        <li
            v-else
            v-for="(result, index) in results"
            :key="index"
            @click="setResult(result)"
            class="autocomplete-result"
            :class="{ 'is-active': index === arrowCounter }"
        >
        {{result}}
        </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'LocationSearch',
  props: {
    name:{
        type: String,
        required: true,
        default:''
    },
    store:{
        type: String,
        required: true,
        default:''
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled:{
        type: Boolean,
        required: false,
        default: false
    },
    id:{
        type: String,
        required: false,
        default:''
    },
    classes:{
        type: String,
        required: false,
        default:''
    },
    reference:{
        type: String,
        required: false,
        default:''
    }
  },
  data() {
    return {
      search: '',
      results: [],
      isOpen: false,
      arrowCounter: -1,
      isLoading:false,
      loadIdx: 0
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  watch: {
    items: function (value, oldValue) {
      this.loadIdx++;
      if (this.isAsync) {
        this.results = value;
        this.isOpen = true;
        this.isLoading = false;
      }
    }
  },
  computed:{
      locSearchValue: {
            get () { return this.$store.getters[this.$props.store + '/' + this.$props.name] },
            set (value) { return this.$store.dispatch(this.$props.store + '/set', {field: this.$props.name, value}) },
        },
  },
  methods: {
    onKeyUp(e){
        console.log('key-up - '+ this.locSearchValue)
        this.$emit('key-up', e, this.locSearchValue);
    },
    filterResults() {
      this.results = this.items.filter(item => item.toLowerCase().indexOf(this.locSearchValue.toLowerCase()) > -1);
    },
    setResult(result) {
      this.locSearchValue = result;
      this.isOpen = false;
      this.$refs[`${this.$props.reference}`].focus();
    },
    onChange() {
        this.$emit('get-locations', this.locSearchValue);

        if (this.isAsync) {
            this.isLoading = true;
        } else {
            this.filterResults();
            this.isOpen = true;
        }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.arrowCounter = -1;
        this.isOpen = false;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
        if(this.isOpen == true){
            this.locSearchValue = this.results[this.arrowCounter];
            this.arrowCounter = -1;
            this.isOpen = false;
            
        }
        this.$refs[`${this.$props.reference}`].focus();
    }
  }
};
</script>

<style>
  .LocationSearch {
    position: relative;
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    min-height: 1em;
    max-height: 6em;
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }
  .autocomplete-result.is-active,
  .autocomplete-result:hover {
    background-color: #4AAE9B;
    color: white;
  }
</style>